import { ChangeEmailPhoneInputState } from "service/shared/others/ChangeEmailPhoneInputService/ChangeEmailPhoneInput.state";

export class ChangeEmailPhoneInputController {
  public readonly state: ChangeEmailPhoneInputState;

  public constructor(state: ChangeEmailPhoneInputState) {
    this.state = state;
  }
}
